"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.agendaSlotSetAccountingInformationApiResponseSchema = void 0;
const zod_1 = require("zod");
exports.agendaSlotSetAccountingInformationApiResponseSchema = zod_1.z.object({
    data: zod_1.z.object({
        workAtTheSameTime: zod_1.z.object({
            morning: zod_1.z.coerce.number(),
            afternoon: zod_1.z.coerce.number(),
            night: zod_1.z.coerce.number(),
        }),
        isFeeApplicable: zod_1.z.coerce.boolean(),
    }),
});
